// A display hint for the most recent successful creation, never persisted or used
// to choose an editor. Shared links still resolve their metadata from the database.
let latest = null;

export function rememberCreatedListTitle(id, title) {
  latest = { id, title };
}

export function getCreatedListTitle(id) {
  return latest && latest.id === id ? latest.title : "";
}
